// src/components/TopBar.tsx
import React from 'react';
import DropDownMenu from './DropDownMenu';
import { useAuth } from '../utils/authContext';
import TimerBox from './TImeBox';


const Header: React.FC = () => {
  const { remainingTime } = useAuth();

  const formatTime = (milliseconds: number | null) => {
    if (milliseconds === null) return 'N/A';

    const totalSeconds = Math.floor(milliseconds / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  };
  
  return (
    <div className="top-bar">
    <div className="logo-div">
      <img src="/logo.png" alt="Logo" style={{ width: '200px', height: 'auto', padding: '10px' }} />
     
    </div>
    <TimerBox remainingTime={remainingTime} formatTime={formatTime} />
    <div className="header-info">
      
       {/* Offcanvas toggle button (only visible on mobile)*/}
        <button className="d-md-none mobmenu" data-bs-toggle="offcanvas" data-bs-target="#sidebar" aria-controls="sidebar" style={{ border: 'none', background: 'none', padding: 0 }}>
            <i className="bi bi-list" style={{ fontSize: '1.5rem' }}></i>
        </button>

       {/*User Info Dropdown Icon*/}
       <DropDownMenu />

    </div>
</div>
  );
};

export default Header;
